import React, { useEffect, useState } from 'react';
import { ValidatorForm } from 'react-form-validator-core';

import { PDFIcon, PlayIcon } from '../Survey/Assets';
import { Dropdown } from '../../Atoms';
import { LinkIcon } from '../../Assets';
import { getResources, getResourceTypes } from '../../redux/actions/Resources';
import { connect } from 'react-redux';
import { Loader } from '../../components';
import Pagination from '../../components/Pagination';
import './resources.scss';
import 'bootstrap/scss/bootstrap.scss';

const Resources = ({
  getResources,
  getResourceTypes,
  resourceTypes: { loading, types },
  resources: { count, results = [] },
  resourceLoading,
}) => {
  const [selected, setResource] = useState('');
  const [activePage, setActivePage] = useState(1);

  const renderIcon = (type) => {
    switch (type) {
      case 'Book':
        return <PDFIcon />;
      case 'Video':
        return <PlayIcon />;
      case 'Link':
        return <LinkIcon />;
      default:
        const { icon } = types.find((t) => t.name === type) || {};
        if (icon) return <img src={icon} style={{ maxWidth: 30 }} />;
        return;
    }
  };

  useEffect(() => {
    getResources();
    getResourceTypes();
  }, []);

  if (loading) return <Loader />;

  const handleChange = ({ target: { value } }) => {
    setResource(value);
    if (selected !== value) {
      getResources(value);
      setActivePage(1);
    }
  };

  const normalizeTypeObj = (types, valueOrObj) => {
  if (!valueOrObj) return undefined;
  if (typeof valueOrObj === 'object') return valueOrObj;               // { id, name, icon? }
  if (typeof valueOrObj === 'number') return types.find(t => t.id === valueOrObj);
  if (typeof valueOrObj === 'string') {
    // could be an id as string OR a name
    const asNum = Number(valueOrObj);
    return (
      types.find(t => t.id === asNum) ||
      types.find(t => (t.name || '').toLowerCase() === valueOrObj.toLowerCase())
    );
  }
  return undefined;
};

const typeMatches = (types, resource, selectedId) => {
  if (!selectedId) return true; // no filter selected
  const rType = normalizeTypeObj(types, resource.resource_type);
  return rType?.id === Number(selectedId);
};

  const filteredResults = selected
  ? results.filter(res => typeMatches(types, res, selected))
  : results;

  const totalRecords = selected ? filteredResults.length : count;

  const getLabel = (resource) => {
    console.log(resource.resource_type);
    const data = [];
    if (resource.website)
      data.push(
        <div>
          <b>Website:</b>{' '}
          <a className="label-value" href={resource.website} target="_blank">
            {resource.website}
          </a>
        </div>
      );

    if (resource.phone_number)
      data.push(
        <div>
          <b>Phone Number:</b>{' '}
          <a
            className="label-value"
            href={`tel:${resource.phone_number}`}
            target="_blank"
          >
            {resource.phone_number}
          </a>
        </div>
      );
    if (resource.email)
      data.push(
        <div>
          <b>Email:</b>{' '}
          <a
            className="label-value"
            href={`mailto:${resource.email}`}
            target="_blank"
          >
            {resource.email}
          </a>
        </div>
      );

    return data;
  };

  const options = types.map((type) => ({ title: type.name, value: type.id }));

  const handleClose = (e) => {
    e.stopPropagation();
    handleChange({ target: { value: '' } });
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    getResources(selected, { page: pageNumber });
  };

  return (
    <div className="main-resources-wrapper">
      <div>
        <header>
          <h4>Helpful Resources</h4>
        </header>
        <div style={{ marginTop: 25 }}>
          <ValidatorForm onSubmit={() => {}}>
            <Dropdown
              value={selected}
              onChange={handleChange}
              handleClose={handleClose}
              title="Resource type"
              name="resource-type"
              options={options}
              closeIcon
            />
          </ValidatorForm>
        </div>
        {resourceLoading ? (
          <Loader isAbsolute />
        ) : (
          <ul className="resources-list">
            {filteredResults.map((resource, index) => (
              <li key={index}>
                <span>
                  <i>{renderIcon(resource.resource_type, types)}</i>
                  <div className="wrapper">
                    <p>{resource.label}</p>
                    <p>{getLabel(resource)}</p>
                  </div>
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        {totalRecords > 1000 && (
            <Pagination
              activePage={activePage}
              totalRecords={totalRecords}
              handleChange={handlePageChange}
              perPage={1000}
            />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  resourceTypes: state.resources.resourceTypes,
  resourceLoading: state.resources.getResources.loading,
  resources: state.resources.resources,
});

const mapDispatchToProps = (dispatch) => ({
  getResources: (value, query) => {
    dispatch(getResources(value, query));
  },
  getResourceTypes: (params) => {
    dispatch(getResourceTypes(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Resources);
